import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialButtons from '../components/SocialButtons';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!form.email || !form.password) {
      setError('이메일과 비밀번호를 입력해주세요');
      return;
    }

    setLoading(true);
    const result = await login(form.email, form.password);
    setLoading(false);

    if (result.success) {
      // 주문하다가 로그인 · 가입하러 온 경우 주문서로 되돌려 보낸다
      const after = sessionStorage.getItem('ws_after_login_order');
      if (after) {
        sessionStorage.removeItem('ws_after_login_order');
        try {
          navigate('/order', { state: JSON.parse(after) });
          return;
        } catch {}
      }
      navigate('/');
    } else {
      setError(result.error || '로그인에 실패했습니다');
    }
  };

  return (
    <>
      <Header />
      <div className="auth-page">
        <div className="auth-card">
          <h2 className="auth-title">로그인</h2>
          <p className="auth-subtitle">WorldShip 계정으로 로그인하세요</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label>이메일</label>
              <input type="email" name="email" value={form.email} onChange={handleChange}
                placeholder="example@email.com" autoFocus />
            </div>
            <div className="auth-field">
              <label>비밀번호</label>
              <input type="password" name="password" value={form.password} onChange={handleChange}
                placeholder="비밀번호 입력" />
            </div>

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: 12 }}>
            <Link to="/forgot-password" style={{ color: '#94a3b8', fontSize: 13, textDecoration: 'none' }}>비밀번호를 잊으셨나요?</Link>
          </div>

          <SocialButtons />

          <div className="auth-footer">
            계정이 없으신가요? <Link to="/register">회원가입</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LoginPage;
